import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralRankingByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': 'थीम',
  'common.themeLight': 'लाइट',
  'common.themeDark': 'डार्क',
  'common.themeActive': 'वर्तमान में सक्रिय',
  'common.themeSwitchToDark': 'डार्क पर स्विच करें',
  'common.themeSwitchToLight': 'लाइट पर स्विच करें',
  'common.settings': 'सेटिंग्स',
  'common.loading': 'लोड हो रहा है…',
  'settings.language': 'भाषा',
  'settings.savePreferences': 'प्राथमिकताएँ सहेजें',
  'settings.savingPreferences': 'सहेजा जा रहा है…',
  'auth.gate.userTitle': 'सत्र सत्यापित हो रहा है',
  'auth.gate.userDescription': 'साइन-इन की पुष्टि हो रही है।',
  'auth.gate.agentTitle': 'सत्र सत्यापित हो रहा है',
  'auth.gate.agentDescription': 'एजेंट साइन-इन की पुष्टि हो रही है।',
  'user.layout.sidebarTitle': 'MineMe उपयोगकर्ता पैनल',
  'user.layout.logout': 'लॉग आउट',
  'user.layout.nav.dashboard': 'डैशबोर्ड',
  'user.layout.nav.deposit': 'जमा',
  'user.layout.nav.withdraw': 'निकासी',
  'user.layout.nav.investments': 'निवेश',
  'user.layout.nav.referral': 'रेफ़रल',
  'user.layout.nav.notifications': 'सूचनाएँ',
  'user.layout.nav.stopLoss': 'स्टॉप-लॉस',
  'user.layout.nav.transactions': 'लेनदेन',
  'user.layout.nav.settings': 'सेटिंग्स',
  'user.layout.balance.available': 'उपलब्ध शेष',
  'user.layout.balance.frozen': 'फ़्रीज़ शेष',
  'user.layout.balance.interest': 'ब्याज शेष',
  'user.layout.balance.bonus': 'बोनस शेष',
  'user.dashboard.balance.available': 'उपलब्ध शेष',
  'user.dashboard.balance.frozen': 'फ़्रीज़ शेष',
  'user.dashboard.balance.interest': 'अर्जित ब्याज',
  'user.dashboard.balance.bonus': 'बोनस शेष',

  'common.time.days': 'दिन',
  'common.time.hours': 'घंटे',
  'common.time.minutes': 'मिनट',
  'common.time.seconds': 'सेकंड',

  'user.dashboard.title': 'डैशबोर्ड',
  'user.dashboard.loadingInvestments': 'निवेश स्थिति लोड हो रही है…',
  'user.dashboard.stats.totalInvested': 'कुल निवेश',
  'user.dashboard.stats.netPnl': 'शुद्ध लाभ / हानि',
  'user.dashboard.stats.activePlans': 'सक्रिय योजनाएँ',
  'user.dashboard.noInvestment.title': 'कोई सक्रिय निवेश नहीं',
  'user.dashboard.noInvestment.subtitle':
    'आज ही निवेश शुरू करें और आकर्षक रिटर्न के साथ अपनी संपत्ति बढ़ाएँ',
  'user.dashboard.noInvestment.cta': 'निवेश योजनाएँ देखें',
  'user.dashboard.recentTx.title': 'हाल के लेनदेन',
  'user.dashboard.recentTx.viewAll': 'सभी देखें',
  'user.dashboard.recentTx.col.date': 'तारीख',
  'user.dashboard.recentTx.col.type': 'प्रकार',
  'user.dashboard.recentTx.col.description': 'विवरण',
  'user.dashboard.recentTx.col.amount': 'राशि',
  'user.dashboard.recentTx.col.status': 'स्थिति',
  'user.dashboard.recentTx.loading': 'हाल के लेनदेन लोड हो रहे हैं…',
  'user.dashboard.recentTx.empty': 'कोई हाल का लेनदेन नहीं।',
  'user.dashboard.tx.Deposit': 'जमा',
  'user.dashboard.tx.Investment': 'निवेश',
  'user.dashboard.tx.Referral': 'रेफ़रल',
  'user.dashboard.tx.Bonus': 'बोनस',
  'user.dashboard.tx.Withdrawal': 'निकासी',
  'user.dashboard.tx.E-Voucher': 'ई-वाउचर',
  'user.dashboard.tx.Stop-Loss': 'स्टॉप-लॉस',
  'user.dashboard.st.Completed': 'पूर्ण',
  'user.dashboard.st.Active': 'सक्रिय',
  'user.dashboard.st.Pending': 'लंबित',
  'user.dashboard.st.Failed': 'विफल',
  'user.dashboard.invest.planFallback': 'योजना',
  'user.dashboard.invest.activeBadge': 'सक्रिय',
  'user.dashboard.invest.detail.amountInvested': 'निवेशित राशि',
  'user.dashboard.invest.detail.currentValue': 'वर्तमान मूल्य',
  'user.dashboard.invest.detail.pl': 'लाभ / हानि',
  'user.dashboard.invest.detail.interestRate': 'ब्याज दर',
  'user.dashboard.invest.detail.perMonth': 'प्रति माह {{pct}}%',
  'user.dashboard.invest.detail.duration': 'अवधि',
  'user.dashboard.invest.detail.months': '{{n}} माह',
  'user.dashboard.invest.detail.startDate': 'आरंभ तिथि',
  'user.dashboard.invest.detail.nextWithdrawal': 'अगली निकासी',
  'user.dashboard.invest.countdownTitle': 'अगली निकासी में',
  'user.dashboard.invest.progress': 'प्रगति',
  'user.dashboard.invest.progressPct': '{{pct}}% पूर्ण',
  'user.dashboard.invest.earlyWithdraw': 'समय से पहले निकासी',
  'user.dashboard.invest.planChip': '{{name}} #{{num}}',
  'user.dashboard.invest.modal.title': 'चेतावनी: समय से पहले निकासी',
  'user.dashboard.invest.modal.investmentAmount': 'निवेश राशि:',
  'user.dashboard.invest.modal.platformFee': 'प्लेटफ़ॉर्म शुल्क ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'छोड़ा गया ब्याज:',
  'user.dashboard.invest.modal.youWillReceive': 'आपको मिलेगा:',
  'user.dashboard.invest.modal.confirmHint': 'जारी रखने के लिए CONFIRM टाइप करें',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'निकासी की पुष्टि करें',
  'user.dashboard.invest.modal.cancelling': 'रद्द हो रहा है…',
  'user.dashboard.invest.toast.cancelled': 'निवेश रद्द',
  'user.dashboard.invest.toast.cancelFailed': 'रद्द नहीं हो सका',

  'notifications.bell.triggerAria': 'सूचनाएँ',
  'notifications.bell.title': 'सूचनाएँ',
  'notifications.bell.loading': 'लोड हो रहा है…',
  'notifications.bell.loadErrorSubtitle': 'सूचनाएँ लोड नहीं हो सकीं',
  'notifications.bell.unreadOne': '1 अपठित अपडेट',
  'notifications.bell.unreadMany': '{{count}} अपठित अपडेट',
  'notifications.bell.allCaughtUp': 'सब अपडेट देख लिए',
  'notifications.bell.markAllRead': 'सभी को पढ़ा हुआ चिह्नित करें',
  'notifications.bell.empty': 'अभी कोई सूचना नहीं',
  'notifications.bell.emptyError': 'सूचनाएँ लोड नहीं हो सकीं',
  'notifications.bell.viewAll': 'सभी देखें',
  'notifications.bell.markReadAria': 'पढ़ा हुआ चिह्नित करें',
  'notifications.bell.time.justNow': 'अभी',
  'notifications.bell.time.secondsAgo': '{{n}} सेकंड पहले',
  'notifications.bell.time.minutesAgo': '{{n}} मिनट पहले',
  'notifications.bell.time.hoursAgo': '{{n}} घंटे पहले',
  'notifications.bell.time.daysAgo': '{{n}} दिन पहले',

  'agent.layout.logout': 'लॉग आउट',
  'agent.layout.nav.dashboard': 'डैशबोर्ड',
  'auth.user.login.title': 'उपयोगकर्ता लॉगिन',
  'auth.user.login.signIn': 'साइन इन',
  'auth.agent.login.title': 'एजेंट लॉगिन',
  'auth.agent.login.signIn': 'साइन इन',

  ...panelSettingsTransactionsByLang.hi,
  ...panelReferralRankingByLang.hi,
  ...panelUserExtraByLang.hi,
  ...panelDwiOverrides.hi,
  ...panelDepositBonusByLang.hi,
  ...panelVoucherStatusByLang.hi,
  ...panelWithdrawBep20ByLang.hi,
  ...panelDepositVoucherOverrides.hi,
  ...panelInvestmentsOverrides.hi,
  'user.investments.card.dailyProfit': 'दैनिक लाभ',
  'user.investments.card.earningDays': 'कार्य दिवस',
  'user.investments.card.earningDaysValue': '{{count}} कार्य दिवस',
  'user.investments.card.expectedProfit': 'अपेक्षित लाभ',
  'user.investments.card.investLimit': 'निवेश सीमा',
  'user.investments.card.investLimitLine': '{{days}} दिन में {{count}}×',
  'user.investments.card.investLimitReached':
    'आपने इस योजना की वर्तमान अवधि की निवेश सीमा पूरी कर ली है।',
  'user.investments.card.limitReached': 'सीमा पूरी',
  ...panelStopLossSlotsAssignOverrides.hi,
  ...panelStopLossFlowByLang.hi,
  ...panelUserSignupSocialForgotByLang.hi,
  ...panelAgentDashboardByLang.hi,
  ...panelAgentReferralsByLang.hi,
  ...panelAgentCommissionsByLang.hi,
  ...panelAgentWithdrawByLang.hi,
  ...panelAgentWithdrawUnlockStringsByLang.hi,
  'agent.withdraw.unlock.loadingTitle': 'निकासी स्थिति जाँची जा रही है…',
  'agent.withdraw.unlock.loadingSubtitle': 'आपकी रेफरल प्रगति और अनलॉक आवश्यकताएँ लोड हो रही हैं',
  'agent.withdraw.form.loadingTitle': 'निकासी विवरण लोड हो रहे हैं…',
  'agent.withdraw.form.loadingHint': 'कृपया प्रतीक्षा करें — बैलेंस और अनलॉक स्थिति लोड हो रही है',
  'agent.withdraw.unlock.requirementMet': 'आवश्यकता पूरी',
  'agent.withdraw.unlock.minDepositHint':
    'केवल रेफ़र किए गए उपयोगकर्ता गिने जाते हैं (उप-एजेंट नहीं)। प्रत्येक के पास पूर्ण जमा में कम से कम ${{amount}} होना चाहिए।',
  ...panelAgentTransactionsByLang.hi,
  ...panelAgentLogsByLang.hi,
  ...panelAgentSettingsByLang.hi,
  ...panelAgentNotificationsByLang.hi,
  ...panelAgentTeamByLang.hi,
  ...panelAgentSignupByLang.hi,
  ...panelAgentLayoutByLang.hi,
  ...panelAgentAuthByLang.hi,
  ...panelUserPlatformTodayByLang.hi,
  ...panelStopLossHowLayoutByLang.hi,
  ...panelSupportTicketsByLang.hi,
});
